<template>
  <div class="login">
    <div class="login-back">
      <img src="../../assets/images/login-back.png" alt="" />
    </div>

    <!-- 登录面板 - 等比缩放容器 -->
    <div class="login-scale-wrapper" ref="scaleWrapper">
      <div class="login-box">
        <div class="left">
          <div class="title1">
            <div class="title1-img">
              <img src="@/assets/images/login-circle.png" alt="">
            </div>
            <span>双派智能</span>
          </div>

          <div class="title2">
            欢迎登录管理后台
          </div>

          <div class="title3">
            双派智能轮椅管理系统，为您提供全面的设备管理、用户监控和数据分功能，助力高效运营。
          </div>

          <div class="title4">
            <div class="title4-block" v-for="(item, index) in 4" :key="index">
              <div class="title4-image">
                <img src="@/assets/images/login-correct.png" alt="">
              </div>
              <span>
                {{ index == 0 ? '全面的设备管理与监控' : index == 1 ? '实时数据统计与分析' : index == 2 ? '多层级权限管理系统' : index == 3 ?
                  '安全可靠的数据保护' : ''
                }}
              </span>
            </div>
          </div>

          <div class="title5">
            @ 2023 双派智能科技 版权所有<span style="margin: 0 5px;">|</span>智能轮椅控制系统
          </div>
        </div>
        <div class="right">
          <div class="right-title">管理员登录</div>
          <div class="right-text">请选择登录方式并输入您的凭据</div>
          <div class="right-tabs">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="账号密码登录" name="first">
                <div class="right-tabs-form">
                  <el-form :model="loginForm" :rules="rules" ref="loginForm0" class="demo-ruleForm">
                    <el-form-item prop="username">
                      <span style="font-weight: bold;">管理员账号（账号：admin）</span>
                      <el-input v-model="loginForm.username" placeholder="请输入管理员账号" size="medium">
                      </el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                      <span style="font-weight: bold;">密码（密码：123456）</span>
                      <el-input :type="!pwdShow ? 'password' : 'text'" v-model="loginForm.password" placeholder="请输入密码"
                        size="medium" show-password>
                      </el-input>
                    </el-form-item>

                    <!-- Base64验证码图片，点击刷新 -->
                    <el-form-item prop="identifying">
                      <span style="font-weight: bold;">图形验证码</span>
                      <div style="display: flex; align-items: center;">
                        <el-input style="width: 70%; display: inline-block;" v-model="loginForm.identifying"
                          placeholder="请输入图形验证码" size="medium">
                        </el-input>

                        <img :src="loginForm.identifyingImg" alt="图形验证码"
                          style="width: 30%; height: 100%; margin-left: 10px; cursor: pointer; border-radius: 4px;"
                          @click="refreshCaptcha">
                      </div>
                    </el-form-item>
                  </el-form>

                </div>

              </el-tab-pane>
              <el-tab-pane label="手机验证码登录" name="second">
                <div class="right-tabs-form">
                  <el-form :model="loginForm" :rules="rules" ref="loginForm1" class="demo-ruleForm">
                    <el-form-item prop="phone">
                      <span style="font-weight: bold;">管理员手机号（手机号为十一位数）</span>
                      <el-input v-model="loginForm.phone" placeholder="请输入管理员手机号" size="medium">
                      </el-input>
                    </el-form-item>

                    <el-form-item prop="code">
                      <span style="font-weight: bold;">管理员手机号验证码</span>
                      <el-input type="text" clearable v-model.trim="loginForm.code" placeholder="验证码">
                        <template slot="append">
                          <el-button type="text" size="small" @click="getCode" :disabled="countDown > 0"
                            class="get-code-btn">
                            {{ countDown > 0 ? `${countDown}s后重新获取` : '获取验证码' }}
                          </el-button>
                        </template>
                      </el-input>
                    </el-form-item>
                  </el-form>

                </div>
              </el-tab-pane>
            </el-tabs>
          </div>

          <div class="right-button" @click="submitForm">
            登录系统
          </div>

          <div class="right-lint"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loginPost, loginPhonePost, loginPhoneRandomImagePost } from "@/api/index";
import { md5 } from "@/utils/md5";

export default {
  data() {
    return {
      loading: false, //登陆状态
      pwdShow: false,
      loginForm: {
        username: "admin",
        password: "123456",
        phone: "",
        code: "",
        identifying: '',
        identifyingImg: '',
        timestamp: ''
      },
      rules: {
        username: [
          { required: true, message: "请输入管理员账号", trigger: "blur" },
          { min: 2, max: 18, message: "长度在 2 到 18 个字符", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, max: 16, message: "长度在 6 到 16 个字符", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入管理员手机号", trigger: "blur" },
          { min: 11, max: 11, message: "手机号必须为11位", trigger: "blur" },
        ],
        code: [
          { required: true, message: "请输入管理员手机号验证码", trigger: "blur" },
          { min: 4, max: 6, message: "长度在 4 到 6 个字符", trigger: "blur" },
        ],
        identifying: [
          { required: true, message: "请输入图形验证码", trigger: "blur" },
        ],
      },
      activeName: 'first',
      countDown: 0,
      timer: null,
      // 设计稿基准尺寸
      designWidth: 1100,
      designHeight: 700,
    };
  },
  created() {
    this.graphicCode()
  },
  mounted() {
    // 初始化缩放
    this.setScale();
    // 监听窗口变化
    window.addEventListener('resize', this.setScale);
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
    window.removeEventListener('resize', this.setScale);
  },
  methods: {
    // 等比缩放计算
    setScale() {
      const wrapper = this.$refs.scaleWrapper;
      if (!wrapper) return;

      // 计算可用宽高（留出安全边距，避免贴边）
      const availableWidth = window.innerWidth - 80;
      const availableHeight = window.innerHeight - 80;

      // 计算宽高缩放比例
      const scaleX = availableWidth / this.designWidth;
      const scaleY = availableHeight / this.designHeight;

      // 取较小值，保证完整显示，不裁剪
      const scale = Math.min(scaleX, scaleY, 1); // 最大不超过1倍，避免放大模糊

      // 应用缩放
      wrapper.style.transform = `translate(-50%, -50%) scale(${scale})`;
    },

    // 图形码
    graphicCode() {
      const timestamp = Date.now();
      this.loginForm.timestamp = timestamp
      let params = timestamp + '?t=' + timestamp
      loginPhoneRandomImagePost(params).then(res => {
        if (res.code == 0) {
          this.loginForm.identifyingImg = res.result
        }
      })
    },
    refreshCaptcha() {
      this.graphicCode()
    },

    handleClick(tab, event) {
      if (this.activeName == 'first') {
        this.$refs.loginForm1.clearValidate();
      } else {
        this.$refs.loginForm0.clearValidate();
      }
    },
    // 获取验证码
    getCode() {
      const isPhoneValid = /^\d{11}$/.test(this.loginForm.phone);
      if (!isPhoneValid) {
        this.$message.error('请先输入合法的11位手机号');
        return;
      }
      this.$message.success('验证码已发送！');
      this.countDown = 60;
      this.timer = setInterval(() => {
        this.countDown--;
        if (this.countDown <= 0) clearInterval(this.timer);
      }, 1000);
    },
    submitForm() {
      if (this.activeName == 'first') {
        this.$refs.loginForm0.validate((valid) => {
          if (!valid) return false;
          this.loading = true;
          this._login();
        });
      } else {
        this.$refs.loginForm1.validate((valid) => {
          if (!valid) return false;
          this.loading = true;
          // this._loginPhone();
        });
      }
    },
    _login() {
      let params = {
        captcha: this.loginForm.identifying,
        checkKey: this.loginForm.timestamp,
        username: this.loginForm.username,
        password: this.loginForm.password,
      };
      loginPost(params).then((res) => {
        if (res.code == 200) {
          let token = res.result.token;
          this.$store.commit("LOGIN_IN", token);
          localStorage.setItem("info", JSON.stringify(res.result.userInfo));
          localStorage.setItem("accessToken", token);
          this.$router.push("/");
          this.loading = false
        } else {
          this.loading = false
        }
      });
    },
    _loginPhone() {
      let params = {
        captcha: "",
        checkKey: "",
        password: "",
        username: "",
      };
      loginPost(params).then((res) => {
        if (res.code == 200) {
          let token = res.resultData.accessToken;
          this.$store.commit("LOGIN_IN", token);
          localStorage.setItem("info", JSON.stringify(res.resultData));
          localStorage.setItem("accessToken", token);
          this.$router.push("/");
          this.loading = false
        } else {
          this.loading = false
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.login {
  height: 100vh;
  width: 100vw;
  position: relative;
  overflow: hidden;

  .login-back {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  /* 等比缩放容器 */
  .login-scale-wrapper {
    position: fixed;
    top: 50%;
    left: 50%;
    transform-origin: center center;
    /* 初始居中，JS 会动态覆盖 scale */
    transform: translate(-50%, -50%) scale(1);
  }

  .login-box {
    /* 固定设计稿尺寸 */
    width: 1100px;
    height: 700px;
    background: #fff;
    border-radius: 20px;
    display: flex;
    align-items: center;
    box-sizing: border-box;

    .left {
      width: 50%;
      height: 100%;
      background: #638AF6;
      border-top-left-radius: 20px;
      border-bottom-left-radius: 20px;
      padding: 0 30px;
      padding-top: 120px;
      box-sizing: border-box;
      position: relative;

      .title1 {
        box-sizing: border-box;
        display: flex;
        align-items: center;

        .title1-img {
          width: 50px;
          height: 50px;
          margin-right: 15px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #7397F8;
          border-radius: 8px;

          img {
            width: 30px;
            height: 30px;
          }
        }

        font-size: 24px;
        letter-spacing: 2px;

        span {
          color: #fff;
          font-weight: bold;
        }
      }

      .title2 {
        margin: 30px 0;
        font-size: 30px;
        letter-spacing: 2px;
        color: #fff;
        font-weight: 600;
      }

      .title3 {
        letter-spacing: 1px;
        font-size: 16px;
        color: #F3F5FE;
        font-weight: 500;
        line-height: 28px;
      }

      .title4 {
        letter-spacing: 1px;
        font-size: 18px;
        color: #fff;
        font-weight: 600;
        line-height: 30px;

        .title4-block {
          display: flex;
          align-items: center;
          margin-top: 20px;

          .title4-image {
            width: 30px;
            height: 30px;
            margin-right: 10px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #7397F8;

            img {
              width: 20px;
              height: 20px;
            }
          }
        }
      }

      .title5 {
        position: absolute;
        bottom: 20px;
        width: calc(100% - 60px);
        text-align: center;

        font-size: 14px;
        color: #fff;
        line-height: 1.5;
      }
    }

    .right {
      width: 50%;
      height: 100%;
      padding: 40px 30px;
      box-sizing: border-box;
      position: relative;

      .right-title {
        text-align: center;
        font-size: 30px;
        letter-spacing: 2px;
        font-weight: 600;
        margin-bottom: 20px;
      }

      .right-text {
        text-align: center;
        font-size: 17px;
        letter-spacing: 1px;
        font-weight: 600;
        color: #838F8F;
        margin-bottom: 20px;
      }

      .right-tabs {
        /deep/ .el-tabs__nav-scroll {
          width: 100%;
          height: 45px;
        }

        /deep/ .el-tabs__nav {
          width: 100%;
          height: 45px;
        }

        /deep/ .el-tabs__item {
          padding: 0;
          width: 50%;
          text-align: center;
          font-size: 15px;
          font-weight: 600;
        }

        /deep/ .el-tabs__item.is-active {
          color: #4B79F6;
        }

        /deep/ .el-tabs__active-bar {
          background-color: #4B79F6;
          height: 2px;
        }

        .right-tabs-form {
          .el-icon-key {
            cursor: pointer;
          }

          .login-code {
            cursor: pointer;
            height: 44px;
          }

          /deep/ .el-input-group {
            height: 44px;
          }

          /deep/ .el-input__inner {
            height: 44px;
          }

          /deep/ .el-button--medium {
            padding: 15px 20px;
            font-size: 16px;
            cursor: pointer;
          }

          /deep/ .el-form-item {
            margin-bottom: 20px;
          }

          /deep/ .el-input-group__append {
            background: #4B79F6;
            color: #fff;
            padding: 0 30px;
            box-sizing: border-box;
          }
        }
      }

      .right-button {
        margin-top: 10px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #4B79F6;
        border-radius: 10px;
        color: #fff;
        font-weight: bold;
        font-size: 15px;
        letter-spacing: 1px;
        cursor: pointer;
      }

      .right-lint {
        width: 100%;
        height: 1px;
        background: #E7E7E7;
        margin: 15px 0px;
      }
    }
  }
}
</style>